import axios from "axios";

export default function submitData() {
  var selectedCountry = document.getElementsByClassName("selected");
  var name = document.getElementById("usernameInput").value;
  var phone_number = document.getElementById("phone_number").value;
  var email = document.getElementById("emailInput").value;
  console.log(selectedCountry);
  var list = [];

  function getCountries() {
    for (var i = 0; i < selectedCountry.length; i++) {
      console.log(selectedCountry[i].parentElement.id);
      console.log(selectedCountry[i].children[0].children[1].innerHTML);
      var object = {
        id: selectedCountry[i].parentElement.id,
        country: selectedCountry[i].children[0].children[1].innerHTML,
      };
      list.push(object);
    }
  }

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function postData(data) {
    axios
      .post("https://bkcountdown.com/nodeapp/addFinalRecord", data)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function sendEmail(email, data) {
    axios
      .post(
        "https://bkcountdown.com/nodeapp/sendEmailFinal_VN",
        {},
        {
          params: {
            email: email,
            FINAL_C1: data.FINAL_C1,
            FINAL_C2: data.FINAL_C2,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function updateFinalRecord_name(name, data) {
    axios
      .put(
        "https://bkcountdown.com/nodeapp/updateFinalRecord_name",
        {},
        {
          params: {
            name: name,
            FINAL_C1: data.FINAL_C1,
            FINAL_C2: data.FINAL_C2,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function updateFinalRecord_phone(phone_number, data) {
    axios
      .put(
        "https://bkcountdown.com/nodeapp/updateFinalRecord_phone",
        {},
        {
          params: {
            phone_number: phone_number,
            FINAL_C1: data.FINAL_C1,
            FINAL_C2: data.FINAL_C2,
          },
        }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function checkRecord_name(name, email, data) {
    axios
      .get("https://bkcountdown.com/nodeapp/checkRecord_name", {
        params: { name: name },
      })
      .then((res) => {
        if (res.data.length > 0) {
          updateFinalRecord_name(name, data);
          sendEmail(email, data);
        } else {
          postData(data);
          sendEmail(email, data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function checkRecord_phone(phone_number, email, data) {
    axios
      .get("https://bkcountdown.com/nodeapp/checkRecord_phone", {
        params: { phone_number: phone_number },
      })
      .then((res) => {
        if (res.data.length > 0) {
          updateFinalRecord_phone(phone_number, data);
          sendEmail(email, data);
        } else {
          postData(data);
          sendEmail(email, data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //Submission with different conditions.
  if (selectedCountry.length < 2) {
    document.getElementById("modal_body").innerHTML =
      "Vui lòng điền tất cả dự đoán";
  } else if (name !== "" && phone_number !== "") {
    document.getElementById("modal_body").innerHTML =
      "Chỉ điền số điện thoại hoặc tên truy cập";
  } else if (name == "" && phone_number == "") {
    document.getElementById("modal_body").innerHTML =
      "Vui lòng điền số điện thoại hoặc tên truy cập";
  } else if (email == "") {
    console.log("email empty");
    document.getElementById("modal_body").innerHTML =
      "Vui lòng điền địa chỉ Email của bạn";
  } else if (isValidEmail(email) !== true) {
    console.log("email format incorrect");
    document.getElementById("modal_body").innerHTML = "Email không hợp lệ";
  } else if (name !== "" && phone_number == "") {
    getCountries();
    var data = {
      name: `${name}`,
      //phone_number: "",
      email: `${email}`,
      region: "VN",
      FINAL_C1: `${list[0].country}`,
      FINAL_C2: `${list[1].country}`,
    };
    checkRecord_name(name, email, data);
    document.getElementById("modal_body").innerHTML =
      "Cảm ơn bạn đã tham gia dự đoán!";
  } else if (name == "" && phone_number !== "") {
    console.log("Submit with phone number!");
    getCountries();
    var data = {
      //name: "",
      phone_number: `${phone_number}`,
      email: `${email}`,
      region: "VN",
      FINAL_C1: `${list[0].country}`,
      FINAL_C2: `${list[1].country}`,
    };
    checkRecord_phone(phone_number, email, data);
    document.getElementById("modal_body").innerHTML =
      "Cảm ơn bạn đã tham gia dự đoán!";
    window.open("https://www.bk8p.com/register?affid=24189");
  }
}
